import { IClassname } from '@/lib/shared/model/classname';

export const SmartTV = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7848)">
        <path
          d="M23.2842 10.6426C23.2703 10.145 23.0665 9.67164 22.7145 9.31967C22.3626 8.9677 21.8892 8.76385 21.3916 8.75"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.9901 10.7172C26.9489 9.2253 26.3379 7.80581 25.2827 6.75034C24.2274 5.69487 22.8081 5.08356 21.3162 5.04199"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.9901 10.7172C26.9489 9.2253 26.3379 7.80581 25.2827 6.75034C24.2274 5.69487 22.8081 5.08356 21.3162 5.04199"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.6961 10.7915C30.6262 8.30558 29.6075 5.94064 27.8489 4.18211C26.0904 2.42357 23.7255 1.40483 21.2395 1.33496"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.6961 10.7915C30.6262 8.30558 29.6075 5.94064 27.8489 4.18211C26.0904 2.42357 23.7255 1.40483 21.2395 1.33496"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8052 26.834V30.6677"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.6936 30.668H17.9169"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3065 26.7779C24.3068 26.8666 24.2886 26.9543 24.2532 27.0355C24.2178 27.1168 24.1659 27.1897 24.1008 27.2498C24.0356 27.3099 23.9587 27.3558 23.8749 27.3846C23.791 27.4133 23.7021 27.4243 23.6138 27.4169C16.4289 26.6425 9.18153 26.6425 1.99659 27.4169C1.90828 27.4243 1.81939 27.4133 1.73556 27.3846C1.65173 27.3558 1.5748 27.3099 1.50966 27.2498C1.44453 27.1897 1.3926 27.1168 1.35719 27.0355C1.32177 26.9543 1.30365 26.8666 1.30396 26.7779V13.4723C1.30365 13.3836 1.32177 13.2959 1.35719 13.2147C1.3926 13.1334 1.44453 13.0605 1.50966 13.0004C1.5748 12.9403 1.65173 12.8944 1.73556 12.8656C1.81939 12.8369 1.90828 12.8259 1.99659 12.8333C9.1816 13.6065 16.4288 13.6065 23.6138 12.8333C23.7021 12.8259 23.791 12.8369 23.8749 12.8656C23.9587 12.8944 24.0356 12.9403 24.1008 13.0004C24.1659 13.0605 24.2178 13.1334 24.2532 13.2147C24.2886 13.2959 24.3068 13.3836 24.3065 13.4723V26.7779Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7848">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
